var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"dark","color":"blue-grey darken-3"}},[_c('v-btn',{staticClass:"ml-1",attrs:{"icon":"icon","dark":"dark"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Protocolo: "+_vm._s(_vm.atendimento))])],1),_vm._v(" "),_c('Chat',{attrs:{"protocolo":_vm.atendimento}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ee159e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modais/ConversaHistorico.vue
// module id = 1004
// module chunks = 0